/**
 * Haggleoff front-end enhancements
 * - scroll reveal
 * - sticky header shadow
 * Intentionally does NOT rewrite third-party app buttons/styles.
 */
(function () {
  if (window.__haggleoffInit) return;
  window.__haggleoffInit = true;

  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    if (prefersReduced || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.hag-reveal').forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var nodes = document.querySelectorAll('.hag-reveal:not(.is-in)');
    if (!nodes.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    nodes.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i * 0.06, 0.3) + 's';
      io.observe(el);
    });
  }

  function initHeader() {
    var header = document.querySelector('.header-wrapper, .section-header');
    if (!header) return;

    var onScroll = function () {
      if (window.scrollY > 8) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /**
   * Hide Shop Pay installment banner under $35 products.
   */
  function initShopPayTermsVisibility() {
    function apply(variantId) {
      document.querySelectorAll('.product__shop-pay-terms[data-shop-pay-min]').forEach(function (wrap) {
        var min = parseInt(wrap.getAttribute('data-shop-pay-min'), 10) || 3500;
        var price = null;
        var jsonEl = wrap.querySelector('script[type="application/json"]');
        if (jsonEl) {
          try {
            var map = JSON.parse(jsonEl.textContent || '{}');
            if (variantId != null && map[String(variantId)] != null) {
              price = Number(map[String(variantId)]);
            }
          } catch (e) {
            /* ignore */
          }
        }
        if (price == null && variantId && typeof variantId === 'object' && variantId.price != null) {
          price = Number(variantId.price);
        }
        if (price == null) return;
        if (price >= min) wrap.removeAttribute('hidden');
        else wrap.setAttribute('hidden', '');
      });
    }

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      try {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var variant = event && event.data && event.data.variant;
          if (!variant) return;
          apply(variant.id != null ? variant.id : variant);
        });
      } catch (e) {
        /* ignore */
      }
    }
  }

  /**
   * Mobile (non-product): show Buy Now in place of cart when cart is empty.
   * When cart gains items, flip back to the cart icon.
   */
  function initMobileHeaderBuy() {
    var buy = document.getElementById('header-buy-now');
    var cart = document.getElementById('cart-icon-bubble');
    if (!buy || !cart) return;
    if (document.body.classList.contains('template-product')) return;

    function cartHasItems() {
      if (cart.querySelector('.cart-count-bubble')) return true;
      var drawer = document.querySelector('cart-drawer');
      if (drawer && !drawer.classList.contains('is-empty')) {
        var items = drawer.querySelectorAll('.cart-item');
        if (items.length) return true;
      }
      return false;
    }

    function sync() {
      var hasItems = cartHasItems();
      buy.classList.toggle('is-hidden', hasItems);
      cart.classList.toggle('hag-cart-mobile-hide', !hasItems);
    }

    sync();

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          requestAnimationFrame(sync);
          setTimeout(sync, 50);
        });
      } catch (e) {
        /* ignore */
      }
    }

    document.addEventListener('cart:updated', sync);
  }

  function boot() {
    initReveal();
    initHeader();
    initMobileHeaderBuy();
    initShopPayTermsVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initMobileHeaderBuy();
    initShopPayTermsVisibility();
  });
})();
